import type { ComponentNameAndModule } from '@sitecore-jss/sitecore-jss-angular';

import { SustainabilityBootstrapModule } from './lib/sustainability.bootstrap.module';

const loadChildren = () =>
  import('./lib/sustainability.lazy.module').then(
    (module) => module.SustainabilityLazyModule
  );

const defineImport = (path: string) => ({
  path,
  loadChildren,
});

const sustainabilityLazyImports: ComponentNameAndModule[] = [
  defineImport('SustainabilityWizard'),
  defineImport('SustainabilityContactForms'),
  defineImport('SustainabilityReturnToScanButton'),
  defineImport('RabobankForm'),
];

export { sustainabilityLazyImports, SustainabilityBootstrapModule };
